import React from 'react'

export default function Block ({ inEditMode }) {
  if (!inEditMode) return null

  return <>Block template is not valid for unpublished content. Change to Draft Mode to view the drafted version.</>
}
